import type { ReactNode } from 'react';

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}

export function SectionHeader({ eyebrow, title, description, actions }: SectionHeaderProps): JSX.Element {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: 'var(--space-6)',
      marginBottom: 'var(--space-6)',
      flexWrap: 'wrap',
    }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)', maxWidth: 760 }}>
        {eyebrow && (
          <span style={{
            fontSize: 12, fontWeight: 600, letterSpacing: '0.24em',
            textTransform: 'uppercase', color: 'var(--text-accent)',
          }}>
            {eyebrow}
          </span>
        )}
        <h2 style={{
          margin: 0,
          fontFamily: 'var(--font-display)',
          fontSize: 32,
          fontWeight: 800,
          letterSpacing: '-0.01em',
          color: 'var(--text-primary)',
          lineHeight: 1.2,
        }}>
          {title}
        </h2>
        {description && (
          <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: 16, lineHeight: 1.5 }}>
            {description}
          </p>
        )}
      </div>
      {actions && <div style={{ display: 'flex', gap: 'var(--space-3)', flexShrink: 0 }}>{actions}</div>}
    </div>
  );
}
